// src/components/billing/PaymentThankYou.jsx
import React, { useEffect } from 'react';
import {
    Typography,
    Container,
    Box,
    Button,
    Card,
    CardContent,
} from '@mui/material';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

const REDIRECT_DELAY_MS = 5000;

export default function PaymentThankYou() {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            // After successful payment, send users to the start page (not /login) to avoid
            // accidental Keycloak redirects when Keycloak mode is enabled.
            navigate('/', { replace: true });
        }, REDIRECT_DELAY_MS);

        return () => {
            clearTimeout(timer);
        };
    }, [navigate]);

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background:
                    'linear-gradient(135deg, rgba(255,165,0,0.08) 0%, rgba(0,0,0,0.02) 100%)',
                py: 6,
            }}
        >
            <Container maxWidth="sm">
                <Card
                    elevation={0}
                    sx={{
                        borderRadius: 4,
                        boxShadow: '0 20px 60px rgba(0,0,0,0.08)',
                        textAlign: 'center',
                        p: { xs: 3, md: 4 },
                    }}
                >
                    <CardContent>
                        <FavoriteBorderIcon
                            sx={{ fontSize: 72, color: 'orange', mb: 2 }}
                        />

                        <Typography variant="h4" fontWeight={700} gutterBottom>
                            Danke für deinen Kauf!
                        </Typography>

                        <Typography variant="body1" color="text.secondary" gutterBottom>
                            Die Zahlung über Mollie war erfolgreich abgeschlossen. <br />
                            Du kannst dich jetzt in dein Schreiberlein Konto einloggen.
                        </Typography>

                        <Button
                            component={RouterLink}
                            to="/login"
                            variant="contained"
                            sx={{
                                mt: 3,
                                backgroundColor: 'orange',
                                '&:hover': { backgroundColor: '#cc7a00' },
                                borderRadius: 2,
                                px: 4,
                                py: 1.2,
                                fontWeight: 600,
                            }}
                        >
                            Zum Login
                        </Button>

                        <Typography
                            variant="caption"
                            color="text.secondary"
                            display="block"
                            sx={{ mt: 2 }}
                        >
                            Automatische Weiterleitung in wenigen Sekunden …
                        </Typography>
                    </CardContent>
                </Card>
            </Container>
        </Box>
    );
}
